<div fxLayout="row wrap" fxLayoutAlign="center" class="p-20">
  <ng-container *ngIf="cargando">
    <div fxLayout="column" fxLayoutAlign="space-between center" >
      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
    </div>
  </ng-container>

  <ng-container *ngIf="!cargando">
    <ng-container *ngIf="stored">
      <div class="statusDiv" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
        <div class="roundEdg done mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
          <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.OK' | translate}}</h2>
          <mat-icon class="ml-20 s-40">check_circle</mat-icon>
        </div>
      </div>

      <div class="mt-40" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
        <div class="mat-elevation-z3 p-20" fxFlex="40" fxLayout="column" fxLayoutAlign="space-between stretch">
          <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_BD.TITULO' | translate}}</h2>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_BD.NUMCOLABS' | translate}}</div>
            <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{colabsEnBD | number:'.0'}}</div>
          </div>
          <mat-divider></mat-divider>
          <div class="mt-20">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_BD.FECHA' | translate}}</div>
            <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{fechaCarga|date:"d MMM y H:mm":offsetPipe:idiomaUtc}} ({{fechaCarga|date:'z':offsetPipe:idiomaActual}})</div>
          </div>
        </div>
        <div class="mat-elevation-z3 p-20" fxFlex="40" fxLayout="column" fxLayoutAlign="start stretch">
          <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_BD.ACCIONES' | translate}}</h2>
          <mat-divider></mat-divider>
          <div class="mt-20" fxLayout="column" fxLayoutAlign="start center">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_BD.WANNADO' | translate}}</div>
            <div class="mt-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch">
              <button mat-raised-button class="mb-20 primary" (click)="descargaExcel()">
                {{'CERTIFICAR.COLABORADORES.CARD_BD.BOTONES.DESCARGA' | translate}}
                <mat-icon class="ml-20">cloud_download</mat-icon>
              </button>
              <button mat-raised-button class="mb-20 warn" (click)="borrarColaboradores()">
                {{'CERTIFICAR.COLABORADORES.CARD_BD.BOTONES.ELIMINA' | translate}}
                <mat-icon class="ml-20">delete_forever</mat-icon>
              </button>

            </div>
          </div>

        </div>
      </div>
      <div  *ngIf="!pasoCompleto" class="statusDivAlert" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}" fxFlex="90">
        <div class="roundEdg alert mat-elevation-z4 pr-20 pl-20 font-size-24 font-weight-300 line-height-1" fxLayout="row" fxLayoutAlign="space-between center">
          <h2>{{'CERTIFICAR.COLABORADORES.ALERT_COLAB' | translate}}</h2>
          <mat-icon class="ml-20 s-40">warning</mat-icon>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!stored">

      <div class="statusDiv">
        <div *ngIf="files.length == 0" class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
          <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.NOBD' | translate}}</h2>
          <mat-icon class="ml-20 s-40">error_outline</mat-icon>
        </div>
        <div *ngIf="files.length > 0 && errores.length > 0" class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
          <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.ERROR' | translate}}</h2>
          <mat-icon class="ml-20 s-40">error_outline</mat-icon>
        </div>
        <div *ngIf="files.length > 0 && errores.length == 0" class="roundEdg primary mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
          <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.PROCES' | translate}}</h2>
          <mat-icon class="ml-20 s-40">error_outline</mat-icon>
        </div>
      </div>

      <!-- formulario inicial -->
      <div *ngIf="!cargandoBD && files.length == 0" class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">

        <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
          [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_NOBD.TITULO' | translate}}</h2>
          <mat-divider></mat-divider>
          <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
            <mat-icon class="s-30 mr-20">filter_1</mat-icon>
            <div class="h3 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_NOBD.PASOS.1' | translate}}</b></div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center stretch" class="mb-20">
            <a mat-raised-button class="primary" fxFlex="60" matTooltip="{{'CERTIFICAR.COLABORADORES.CARD_NOBD.TOOLTIP' | translate}}"
              [href]="urlAssets + 'platform/plantillasBD/' + instituto + '/CollaboratorsListTemplate_' + idiomaActual + '.xlsm'" download (click)="ModalArchivo()">
              {{'CERTIFICAR.COLABORADORES.CARD_NOBD.FILE' | translate}}
              <mat-icon class="ml-20">save_alt</mat-icon>
            </a>
          </div>
          <mat-divider></mat-divider>
          <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
            <mat-icon class="s-30 mr-20">filter_2</mat-icon>
            <div class="h3 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_NOBD.PASOS.2' | translate}}</b></div>
          </div>
          <mat-divider></mat-divider>
          <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
            <mat-icon class="s-30 mr-20">filter_3</mat-icon>
            <div class="h3 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_NOBD.PASOS.3' | translate}}</b></div>
          </div>
          <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop
            (onFileDropped)="uploadFile($event)" *ngIf="totRows == 0 && !cargandoBD"
            [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <input hidden type="file" #fileInput (change)="onFileChange($event)" accept="application/vnd.ms-excel.sheet.macroEnabled.12, application/vnd.ms-excel.sheet.macroenabled.12">
            <h1>{{'CERTIFICAR.COLABORADORES.UPLOAD' | translate}}</h1>
          </div>
        </div>

      </div>

      <!-- formulario cuando no hay errores -->
      <div *ngIf="!guardandoBD && arregloColaboradores.length > 0 && errores.length == 0" class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">

        <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
        *ngFor="let file of files;let i=index"  [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_NOERR.TITULO' | translate}}</h2>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_NOERR.NUMCOLABS' | translate}}</div>
            <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{arregloColaboradores.length | number:'.0'}}</div>
          </div>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_NOERR.FILENAME' | translate}}</div>
            <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{ file }}</div>
          </div>
          <mat-divider></mat-divider>
          <div class="mt-20 h2 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_NOERR.GUARDAR' | translate}}</div>
          <div class="mt-20" fxLayout="row" fxLayoutAlign="space-between stretch">
            <button mat-raised-button class="warn" fxFlex="45" (click)="deleteAttachment(i,true)">
              {{'CERTIFICAR.COLABORADORES.CARD_NOERR.BOTONES.NO' | translate}}
            </button>
            <button mat-raised-button class="primary" fxFlex="45" (click)="guardarColaboradoresBD()">
              {{'CERTIFICAR.COLABORADORES.CARD_NOERR.BOTONES.SI' | translate}}
            </button>
          </div>
        </div>

      </div>

      <!-- formulario cuando hay errores -->
      <div *ngIf="errores.length > 0" class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">

        <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
          *ngFor="let file of files;let i=index" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.TITULO' | translate}}</h2>
          <mat-divider></mat-divider>
          <div fxLayout="row" fxLayoutAlign="space-between stretch">
            <div class="mt-20 mb-20" fxFlex="50">
              <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.ROWS_OK' | translate}}</div>
              <div fxLayout="row" fxLayoutAlign="start center">
                <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{arregloColaboradores.length}}</div>
                <mat-icon class="s-50 ml-20">done</mat-icon>
              </div>
            </div>
            <div class="mt-20 mb-20" fxFlex="50">
              <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.ROWS_NOTOK' | translate}}</div>
              <div fxLayout="row" fxLayoutAlign="start center">
                <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{errores.length}}</div>
                <mat-icon class="s-50 ml-20">close</mat-icon>
              </div>
              <div class="h4 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.MOREINFO' | translate}}</b></div>
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.FILENAME' | translate}}</div>
            <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{ file }}</div>
          </div>
          <mat-divider></mat-divider>
          <div class="mt-20 h2 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.GUARDAR' | translate}}</div>
          <button mat-raised-button class="warn mt-20" (click)="deleteAttachment(i,true)">
            {{'CERTIFICAR.COLABORADORES.CARD_ERRFND.DELETE' | translate}}
          </button>
        </div>

      </div>

      <!-- listado de errores -->
      <div *ngIf="errores.length > 0" class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">

        <div class="mat-elevation-z3 p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between stretch"
          [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <div fxLayout="row" fxLayoutAlign="space-between stretch">
            <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.TITULO.1' | translate}}{{errores.length}}</h2>
            <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.TITULO.2' | translate}}{{erroresTotales}}</h2>
          </div>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">

            <mat-accordion>

              <ng-container *ngFor="let error of errores; index as i;">
                <mat-expansion-panel class="mb-20">

                  <mat-expansion-panel-header class="accent-50">
                    <mat-panel-title>
                      <b>{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.INFO.ROW' | translate}}{{error.numeroFila}}</b>
                      <b class="ml-20">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.INFO.ERRNUM' | translate}}{{error.listaErrores.length}}</b>
                    </mat-panel-title>
                    <mat-panel-description>
                      {{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.INFO.SHOW' | translate}}
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <div *ngFor="let detalleError of error.listaErrores" class="mat-elevation-z3 p-20 mt-20 mb-20" fxLayout="column" fxLayoutAlign="space-between stretch">

                    <div fxLayout="row" fxLayoutAlign="space-between stretch">
                      <div fxFlex="50" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="">
                          <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.TIPO' | translate}}</div>
                          <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.ERRORES.'+detalleError.tipoError | translate}}</div>
                        </div>
                        <button mat-icon-button color="primary" aria-label="aiuda" class="mr-20" (click)="infoError(detalleError.tipoError)">
                          <mat-icon class="s-40">help</mat-icon>
                        </button>
                      </div>
                      <div fxFlex="50">
                        <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.COLUMNA' | translate}}</div>
                        <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{detalleError.columna}}</div>
                      </div>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="mt-20">
                      <!-- <div fxFlex="50">
                        <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.DESCR' | translate}}</div>
                        <div class="h3 secondary-text pr-20"><b>{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DESCRIPCION.'+detalleError.tipoError | translate}}</b></div>
                      </div>
                      <div fxFlex="50">
                        <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.DATO' | translate}}</div>
                        <div class="datoErroneo">{{detalleError.dato}}</div>
                      </div> -->
                      <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.DATO' | translate}}</div>
                      <table fxFlex="100" class="tablaError mt-8">
                        <tr>
                          <td width="10%" class="esi"></td>
                          <td width="90%" class="esd">{{detalleError.numeroColumna}}</td>
                        </tr>
                        <!-- <tr>
                          <td width="10%" class="cizq"></td>
                          <td width="90%" class="cnme">{{detalleError.columna}}</td>
                        </tr> -->
                        <tr>
                          <td class="eii">{{error.numeroFila}}</td>
                          <td class="datoErroneo">{{detalleError.dato}}</td>
                        </tr>
                      </table>
                    </div>

                  </div>

                </mat-expansion-panel>
              </ng-container>


            </mat-accordion>

          </div>
        </div>

      </div>

      <!-- pantalla "cargando" y "guardando" -->
      <div class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">
        <!--- cargando excel en front --->
        <div *ngIf="cargandoBD" class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
          [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.CARGA.TITULO' | translate}}</h2>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.CARGA.INFO' | translate}}</div>
            <mat-progress-bar mode="indeterminate" class="mt-20"></mat-progress-bar>
          </div>
        </div>
        <!--- guardando registros en back --->
        <div *ngIf="guardandoBD" class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
          [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.GUARDA.TITULO' | translate}}</h2>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.GUARDA.INFO' | translate}}</div>
            <mat-progress-bar mode="indeterminate" class="mt-20"></mat-progress-bar>
          </div>
        </div>
      </div>

    </ng-container>
  </ng-container>


  <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
    <button *ngIf="!pasoCompleto && !cargando" (click)="completarPaso()" mat-fab aria-label="boton completar paso"
      matTooltip="{{'CERTIFICAR.ADICIONALES.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20"
      (click)="completarPaso()"
    >
      <mat-icon>done</mat-icon>
    </button>
    <button *ngIf="pasoCompleto && !cargando" (click)="completarPaso()" mat-raised-button class="done mr-20">
      {{'CERTIFICAR.ADICIONALES.STATUS.DONE' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>

    <!-- desbloquearPaso -->
    <button *ngIf="pasoCompleto && !cargando && (validationUser || desbloqueoEstatus)" (click)="desbloquearColaboradores()" mat-fab aria-label=""
      matTooltip="{{'CERTIFICAR.ADICIONALES.STATUS.LOCK' | translate}}" matTooltipPosition="left" class="undone mr-20"
      >
      <mat-icon>lock_open</mat-icon>
    </button>

    <button *ngIf="!pasoCompleto && !cargando && (validationUser || desbloqueoEstatus)" (click)="desbloquearColaboradores()" mat-raised-button class="reopen mr-20">
      {{'CERTIFICAR.ADICIONALES.STATUS.UNLOCK' | translate}}
      <!-- <mat-icon class="ml-20">lock_open</mat-icon> -->
    </button>
  </div>

</div>
